import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveWixPaymentsPlatformV1CheckoutSessionsUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'www.wixapis.com': [
      {
        srcPath: '/payments/platform/v1/checkout-sessions',
        destPath: '/v1/checkout-sessions',
      },
      {
        srcPath: '/payments/base44/v1/subscriptions',
        destPath: '/v1/subscriptions',
      },
      {
        srcPath: '/payments/platform/v1/service-plugin-registrations',
        destPath: '/v1/service-plugin-registrations',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/checkout-sessions',
        destPath: '',
      },
    ],
    'manage.base44.com': [
      {
        srcPath: '/_api/checkout-sessions',
        destPath: '',
      },
    ],
    'payments.base44.com': [
      {
        srcPath: '/_api/checkout-sessions',
        destPath: '',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/payments/platform/v1/checkout-sessions',
        destPath: '/v1/checkout-sessions',
      },
    ],
    _: [
      {
        srcPath: '/payments/platform/v1/checkout-sessions',
        destPath: '/v1/checkout-sessions',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_payments_checkout-sessions';

/**
 * Creates a Wix-hosted checkout session for the supplied line items and returns its redirect URL
 * and session ID.
 *
 * Each call creates a new, independent session. The method isn't idempotent, so a retry produces
 * an additional session rather than recovering the prior one.
 */
export function generateCheckoutSession(
  payload: object
): RequestOptionsFactory<any> {
  function __generateCheckoutSession({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.payments.platform.v1.checkout_session',
      method: 'POST' as any,
      methodFqn:
        'wix.payments.platform.v1.CheckoutSessions.GenerateCheckoutSession',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveWixPaymentsPlatformV1CheckoutSessionsUrl({
        protoPath: '/v1/checkout-sessions/generate',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __generateCheckoutSession;
}
